import digitalData from 'digital-data';
import {
  OVERLAY,
  REFRESH_QUOTE_INFO_OVERLAY_EVENT
} from '../constants';

export const quoteDashboard = () => {
  window.LIFE_CYCLE_EVENT_BUS.on('refresh-quote-info-overlay.event', () => {
    const refreshQuoteInfoOverlayEventData = {
      category: {
        primaryCategory: OVERLAY,
      },
      eventInfo: { eventName: REFRESH_QUOTE_INFO_OVERLAY_EVENT },
    };
    digitalData.event.push(refreshQuoteInfoOverlayEventData);
  });
};
